
export interface Country {
    name: string;
    nameFull: string;
    code: CountryCode;
    displayCode: string;
    combinedDisplayCode: string;
    makeMethod: string;
    theme: boolean;
    currency: string;
    currencyName: string;
    currencyWithCountry: string;
    maxImageSize: number;
    imageOptions: {
        maxSize: number;
        fileType: string[];
    }
    maxGoodNumberPerClass: number;
    paymentMethodsImageName: string;
    stripeKey: string | undefined;
    autoSelectedInForm: boolean;
}

export const enum CountryCode {
    AU = 'AU',
    UK = 'UK',
    GB = 'GB',
    NZ = 'NZ',
    SG = 'SG',
    MY = 'MY',
    BX = 'BX',
    BENELUX = 'BENELUX',
    BE = 'BE',
    NL = 'NL',
    LU = 'LU',
    HK = 'HK',
}
